import { alpha } from '@mui/material/styles';

export const customersStyles = (theme) => ({
  root: {
    padding: theme.spacing(2),
    paddingTop: theme.spacing(1),
    backgroundColor: '#ffffff',
    minHeight: 'calc(100vh - 64px)', // Adjust for header height
    width: '100%',
    boxSizing: 'border-box',
    overflowX: 'hidden',
  },
  pageHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    padding: theme.spacing(1, 2),
    borderRadius: '8px',
    '& h1': {
      fontSize: '1.5rem',
      fontWeight: 500,
      color: theme.palette.text.primary,
      margin: 0,
    }
  },
  addButton: {
    borderRadius: '4px',
    padding: '6px 16px',
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    }
  },
  searchSection: {
    marginBottom: theme.spacing(2),
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center',
  },
  searchField: {
    flex: 1,
    '& .MuiOutlinedInput-root': {
      borderRadius: '4px',
    }
  },
  searchButton: {
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    borderRadius: '4px',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    }
  },
  tableContainer: {
    backgroundColor: '#fff',
    borderRadius: '4px',
    boxShadow: theme.shadows[1],
  },
  table: {
    '& .MuiTableCell-head': {
      backgroundColor: '#f5f5f5',
      color: theme.palette.text.primary,
      fontWeight: 500,
      fontSize: '0.825rem',
      padding: theme.spacing(1),
      height: '40px',
    },
    '& .MuiTableCell-body': {
      fontSize: '0.825rem',
      padding: theme.spacing(0.75, 1),
      height: '40px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '200px',
    }
  },
  creditCell: {
    textAlign: 'right',
    fontWeight: 500,
  },
  actionButtons: {
    display: 'flex',
    justifyContent: 'center',
    '& .MuiIconButton-root': {
      padding: 4,
      marginLeft: 2,
      color: '#2E3B55',
      '&:hover': {
        backgroundColor: alpha('#2E3B55', 0.08),
      },
      '& .MuiSvgIcon-root': {
        fontSize: '1.1rem',
      }
    }
  },
  dialog: {
    '& .MuiDialog-paper': {
      borderRadius: '4px',
    }
  },
  dialogTitle: {
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    '& .MuiTypography-root': {
      fontSize: '1.25rem',
      fontWeight: 500,
    }
  },
  dialogContent: {
    padding: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  formField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '4px',
    },
    '& .MuiInputLabel-root': {
      color: theme.palette.text.secondary,
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: theme.palette.primary.main,
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    }
  },
  dialogActions: {
    padding: theme.spacing(2),
    paddingTop: theme.spacing(1),
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  deleteDialog: {
    '& .MuiDialog-paper': {
      borderRadius: '4px',
      minWidth: '400px',
    }
  },
  deleteDialogContent: {
    padding: theme.spacing(3),
    paddingTop: theme.spacing(2),
    '& .MuiTypography-root': {
      color: theme.palette.text.primary,
    }
  },
  pagination: {
    padding: theme.spacing(1),
    borderTop: '1px solid rgba(46, 59, 85, 0.1)',
    '& .MuiPaginationItem-root': {
      color: '#2E3B55',
    },
    '& .MuiToolbar-root': {
      minHeight: '40px',
      height: '40px',
    }
  },
  snackbar: {
    '& .MuiAlert-root': {
      borderRadius: 12,
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    }
  }
}); 